module.exports = __webpack_public_path__ + "static/media/Slide1.394c2046.jpg";